import * as React from "react";
import Modal from "@mui/material/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import CheckIcon from "@mui/icons-material/Check";
import { green } from "@mui/material/colors";
import {
  ButtonWrapper,
  StyledBox,
  StyledBoxBorder,
  StyledBoxCard,
  StyledBoxColorInfo,
  StyledBoxFlex,
  StyledFlexBox,
  StyledTypography,
  StyledTypographyGroupCart,
  StyledTypographyLabel,
} from "./style";
import CustomButton from "../../common/button/CustomButton";
import profile from "../../../assets/images/vector-shop-icon.png";
import theme from "../../../theme";
import CrossIcon from "../../../assets/Icons/CrossIcon";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import CustomChip from "../../common/chip/chip";
import { StyledBoxAuto } from "../auto-split-calculation/style";
import CustomInput from "../../common/input/CustomInput";
import SendIcon from "../../../assets/Icons/SendIcon";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { GROUP_CART_SINGLE, INVITE_MEMBER } from "../../../actions/group-cart-actions";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { formatName } from "../../../utils/common";

export default function InviteMembers({ open, handleClose, cartId }) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (open && cartId) {
      dispatch({ type: GROUP_CART_SINGLE, payload: { id: cartId } });
    }
  }, [open, cartId, dispatch]);

  const profileDetails = useSelector((state) => state.auth?.profileDetails);
  const singleCart = useSelector((state) => state?.groupCartData?.singleCart);

  const currentUserEmail = profileDetails?.email?.trim()?.toLowerCase();
  const cartCreatorEmail = singleCart?.create_by_user?.email?.trim()?.toLowerCase();
  const shouldShowInvitationSection =
    currentUserEmail && cartCreatorEmail && currentUserEmail === cartCreatorEmail;
  const memberInvitationList = singleCart?.members_invitation;

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    invite_emailId: Yup.string()
      .email("Invalid email")
      .required("Email is required"),
  });

  // ✅ Local states for button feedback
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  return (
    <Modal open={open} onClose={handleClose}>
      <StyledBox>
        <StyledBoxCard>
          <StyledBoxFlex>
            <img src={profile} alt="profile" loading="lazy" />
            <StyledTypography>Auto Split Cost Calculation</StyledTypography>
          </StyledBoxFlex>
          <CrossIcon color={theme.palette.custom.white} onClick={handleClose} />
        </StyledBoxCard>

        <StyledBoxAuto sx={{ flex: 1, overflowY: "auto", minHeight: 0 }}>
          <StyledBoxColorInfo>
            <StyledTypographyGroupCart>
              Group cart information
            </StyledTypographyGroupCart>
            <Grid container spacing={1}>
              <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <StyledTypographyLabel>Cart name:</StyledTypographyLabel>
              </Grid>
              <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <StyledTypographyLabel isactive="true">
                  {singleCart?.cart_name}
                </StyledTypographyLabel>
              </Grid>
              <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <StyledTypographyLabel>Timeline:</StyledTypographyLabel>
              </Grid>
              <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <StyledTypographyLabel isactive="true">
                  {singleCart?.cart_timeline} Days
                </StyledTypographyLabel>
              </Grid>
              <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <StyledTypographyLabel>Payment Option:</StyledTypographyLabel>
              </Grid>
              <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <StyledTypographyLabel isactive="true">
                  {formatName(singleCart?.payment_options)}
                </StyledTypographyLabel>
              </Grid>
              <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <StyledTypographyLabel>Members:</StyledTypographyLabel>
              </Grid>
              <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <StyledTypographyLabel isactive="true">
                  {`${singleCart.cart_members?.length ?? 0} `} Member
                </StyledTypographyLabel>
              </Grid>
            </Grid>
          </StyledBoxColorInfo>

          <StyledFlexBox>
            <StyledTypographyGroupCart isgap="true">
              Invite Members
            </StyledTypographyGroupCart>
            <StyledTypographyGroupCart isactive="true" isgap="true">
              {memberInvitationList?.length ?? 0} members
            </StyledTypographyGroupCart>
          </StyledFlexBox>

          {shouldShowInvitationSection && (
            <Formik
            initialValues={{ name: "", invite_emailId: "" }}
            validationSchema={validationSchema}
            onSubmit={(values, { resetForm, setStatus, setFieldError }) => {
              setStatus({ error: "" });

              if (values.invite_emailId === profileDetails?.email) {
                setFieldError("invite_emailId", "You cannot invite yourself");
                return;
              }

              setLoading(true);
              setSuccess(false);

              dispatch({
                type: INVITE_MEMBER,
                payload: {
                  ...values,
                  groupCartId: cartId,
                },
                onSuccess: () => {
                  setLoading(false);
                  setSuccess(true);
                  resetForm();
                  setTimeout(() => handleClose(), 1000);
                },
                onError: (errorMessage) => {
                  setLoading(false);
                  setSuccess(false);
                  setStatus({ error: errorMessage });
                },
              });
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              status,
            }) => (
              <Form id="invite-member-form" onSubmit={handleSubmit}>
                <Grid container columnSpacing={2}>
                  <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                    <CustomInput
                      color={theme.palette.custom.productTextColor}
                      fontSize={theme.typography.regular.fontSize}
                      height="10px"
                      issize="true"
                      required
                      placeholder="Anil Kapoor"
                      customLabel="Name"
                      name="name"
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.name && Boolean(errors.name)}
                      helperText={touched.name && errors.name}
                    />
                  </Grid>

                  <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                    <CustomInput
                      issize="true"
                      color={theme.palette.custom.productTextColor}
                      fontSize={theme.typography.regular.fontSize}
                      height="10px"
                      required
                      placeholder="Email Address"
                      customLabel="Email Address"
                      name="invite_emailId"
                      value={values.invite_emailId}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        touched.invite_emailId &&
                        Boolean(errors.invite_emailId)
                      }
                      helperText={
                        touched.invite_emailId && errors.invite_emailId
                      }
                    />
                  </Grid>
                </Grid>

                {status?.error && (
                  <Box mt={1}>
                    <StyledTypographyLabel
                      style={{
                        color: theme.palette.error.main,
                        fontWeight: 500,
                      }}
                    >
                      {status.error}
                    </StyledTypographyLabel>
                  </Box>
                )}
              </Form>
            )}
          </Formik>
          )}

          {shouldShowInvitationSection && memberInvitationList?.length > 0 && (
            <StyledBoxBorder>
              <StyledTypographyGroupCart>
                Invited Members
              </StyledTypographyGroupCart>
              <Box>
                {memberInvitationList?.map((invite, index) => {
                  const { color, background } =
                    invite?.invitation_status === "pending"
                      ? {
                          color: theme.palette.custom.pendChipColor,
                          background:
                            theme.palette.custom.pendChipBg,
                        }
                      : invite?.invitation_status === "accepted"
                      ? {
                          color: theme.palette.custom.acceptedChipColor,
                          background:
                            theme.palette.custom.acceptedChipBg,
                        }
                      : invite?.invitation_status === "rejected"
                      ? {
                          color: theme.palette.custom.rejectedChipColor,
                          background:
                            theme.palette.custom.rejectedChipBg,
                        }
                      : {
                          color: theme.palette.custom.chipJoinColor,
                          background:
                            theme.palette.custom.chipJoinBg,
                        };
                  return (
                    <Box key={index}>
                      <StyledFlexBox>
                        <StyledTypographyLabel>
                          {invite?.name}
                        </StyledTypographyLabel>
                        <CustomChip
                          title={invite?.invitation_status}
                          color={color}
                          background={background}
                          padding="6px 18px"
                          fontSize={theme.typography.mini.fontSize}
                        />
                      </StyledFlexBox>
                      <StyledTypographyLabel
                        color={theme.palette.custom.notProvide}
                      >
                        {invite?.invite_emailId}
                      </StyledTypographyLabel>
                    </Box>
                  );
                })}
              </Box>
            </StyledBoxBorder>
          )}
        </StyledBoxAuto>

        <ButtonWrapper>
          <CustomButton
            padding="10px 64px"
            fontSize={theme.typography.regular.fontSize}
            height="44px"
            btnLabel="Close"
            btntype={"white"}
            color={theme.palette.custom.lockerValueColor}
            fontWeight={theme.typography.fontWeight.medium}
            border={theme.borders.defaultButton}
            onClick={() => handleClose()}
          />
          {shouldShowInvitationSection && (
            <Box sx={{ position: "relative", display: "inline-flex" }}>
              <CustomButton
                form="invite-member-form"
                fontSize={theme.typography.regular.fontSize}
                color={theme.palette.custom.white}
                type="submit"
                padding="10px 24px"
                btnLabel={success ? "Invitation Sent" : "Send Invitation"}
                btntype={success ? "success" : "warning"}
                height="44px"
                startIcon={success ? <CheckIcon /> : <SendIcon />}
                disabled={loading}
                sx={{
                  backgroundColor: success ? green[500] : undefined,
                  "&:hover": {
                    backgroundColor: success ? green[700] : undefined,
                  },
                }}
              />
              {loading && (
                <CircularProgress
                  size={24}
                  sx={{
                    color: green[500],
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: "-12px",
                    marginLeft: "-12px",
                  }}
                />
              )}
            </Box>
          )}
        </ButtonWrapper>
      </StyledBox>
    </Modal>
  );
}
